import React, { useEffect, useRef } from 'react';
import LazyImage from './LazyImage';
import './vitrine-overrides.css';

// Componente da Vitrine com navegação opcional e animação suave
const Vitrine = ({ id, title, items, showNavigation = true }) => {
  const containerRef = useRef(null);
  const swiperInstanceRef = useRef(null);

  useEffect(() => {
    const initSwiper = () => {
      if (!window.Swiper || !containerRef.current || swiperInstanceRef.current) return;

      swiperInstanceRef.current = new window.Swiper(containerRef.current, {
        slidesPerView: 1.15,
        spaceBetween: 12,
        speed: 600,
        watchOverflow: true,
        // Evita grande espaço vazio no final, preenchendo com blanks virtuais
        loop: false,
        slidesPerGroup: 1,
        centeredSlides: false,
        // Sempre define navigation; CSS decide se mostra
        navigation: {
          nextEl: `.vitrine-${id} .swiper-button-next`,
          prevEl: `.vitrine-${id} .swiper-button-prev`,
        },
        pagination: {
          el: `.vitrine-${id} .swiper-pagination`,
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
        breakpoints: {
          420: { slidesPerView: 1.35, spaceBetween: 12 },
          640: { slidesPerView: 2.2, spaceBetween: 16 },
          768: { slidesPerView: 3.1, spaceBetween: 20 },
          1024: { slidesPerView: 4, spaceBetween: 24 },
          1366: { slidesPerView: 5, spaceBetween: 24 }
        },
      });
    };

    // Tenta iniciar imediatamente
    initSwiper();

    // E também quando o script do Swiper sinalizar que está pronto
    const onReady = () => initSwiper();
    document.addEventListener('swiper-ready', onReady);

    return () => {
      document.removeEventListener('swiper-ready', onReady);
      if (swiperInstanceRef.current) {
        try { swiperInstanceRef.current.destroy(true, true); } catch (e) {}
        swiperInstanceRef.current = null;
      }
    };
  }, [id, showNavigation]);

  return (
    <div className="swiper-vitrine" id={`grupo-vitrine-${id}`}>
      <div className="vitrine-title text-left pt-sm-4">
        <span>{title}</span>
      </div>
      <div className={`swiper-container vitrine-${id}`} data-vitrine-id={id} ref={containerRef}>
        <div className="swiper-wrapper">
          {items.map((item, index) => (
            <div key={index} className="swiper-slide row-3 item-box item-box-produto">
              <a href={item.href}>
                <div className="wrapper">
                  <LazyImage
                    src={item.imageLarge}
                    alt={`Content ${index + 1}`}
                    className="course-image"
                  />
                </div>
              </a>
            </div>
          ))}
        </div>
        {/* Renderizamos as setas sempre, mas escondemos via CSS quando não precisar */}
        <div className={`swiper-button-next ${showNavigation ? '' : 'hidden'}`} />
        <div className={`swiper-button-prev ${showNavigation ? '' : 'hidden'}`} />
        <div className="swiper-pagination" />
      </div>
    </div>
  );
};

export default Vitrine;
